import './mobile-menu';

// (function main($) {
//   $(() => {
//     AOS.init();
//     // Include your main JS generic code here
//   });
// }(jQuery));

document.addEventListener("DOMContentLoaded", function() {
  var placeholder = document.getElementById('videoPlaceholder');
  var playButton = document.getElementById('playButton');
  var videoEmbed = document.getElementById('videoEmbed');

  playButton.addEventListener('click', function() {
    placeholder.style.display = 'none';
    videoEmbed.src += '&autoplay=1'; // Autoplay video when button is clicked
  });
});